import { StyleSheet } from 'aphrodite'
import main from './main'
import lists from './lists'
import paragraphs from './paragraphs'
import headers from './headers'
import links from './links'

export default {
  main: StyleSheet.create(main),
  lists: StyleSheet.create(lists),
  paragraphs: StyleSheet.create(paragraphs),
  headers: StyleSheet.create(headers),
  links: StyleSheet.create(links)
}



// WEBPACK FOOTER //
// ./src/components/Privacy/style/index.js